import { Box, Brand, BODY_INK, Img, INK, LogoAt, Page, Text } from "../primitives";
/** Reference page 5 — «من نحن» body. Line breaks are fixed to the reference. */
const LINES = [
    "أرتيكا هي شركة عراقية متخصصة في تقديم وتنفيذ حلول فنية ذكية ومصمّمة حسب الطلب، تجمع بين الفن والتكنولوجيا واللمسة الإنسانية. تبدأ أعمالنا من",
    "التصميم الرقمي، وتُصقل بلمسات يدوية راقية، لتُنفّذ بجودة استثنائية تلائم المساحات السكنية والتجارية والمعمارية. ويعمل فريقنا من المعماريين والمصممين",
    "المحترفين على ضمان انسجام كل عمل فني مع طبيعة المشروع وذوق العميل بشكل دقيق.",
];
const TOPS = [627, 654, 681];
export function AboutUsPage() {
    return (<Page>
      <Box x={0} y={0} w={1125} h={555.2} style={{ background: INK }}/>
      <Box x={6.6} y={6.6} w={1112} h={541.7} style={{ overflow: "hidden" }}>
        <Img src="/proposal-assets/template/about-photo.jpg" x={0} y={0} w={1112} h={541.7}/>
        <Box x={0} y={0} w={1112} h={541.7} style={{ background: INK, opacity: 0.551 }}/>
      </Box>
      <LogoAt cx={78.7} cy={95.5} w={31} color="#ffffff"/>
      <Brand right={1057} top={67} size={33} color="#ffffff"/>

      {LINES.map((line, i) => (<Text key={i} right={1058} top={TOPS[i]} size={17} weight={300} color={BODY_INK} width={996} justify={i < LINES.length - 1}>
          {line}
        </Text>))}
    </Page>);
}
